import { useForm } from 'react-hook-form';
import Input from '../common/Input';
import Button from '../common/Button';

export default function ContactForm() {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();
  const onSubmit = async (values) => {
    // placeholder: integrate with mailer if desired
    alert(JSON.stringify(values, null, 2));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Input label="Ime" {...register('name', { required: 'Obavezno polje' })} error={errors.name?.message} />
      <Input label="Email" type="email" {...register('email', { required: 'Obavezno polje' })} error={errors.email?.message} />
      <Input label="Poruka" as="textarea" rows={4} {...register('message', { required: 'Obavezno polje' })} error={errors.message?.message} />
      <Button type="submit" disabled={isSubmitting}>Pošalji</Button>
    </form>
  );
}
